import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'

// Layouts
import AdminLayout from './components/AdminLayout'
import FacilitatorLayout from './components/FacilitatorLayout'

// Public pages
import LandingPage from './pages/LandingPage'
import Login from './pages/Login'
import FacilitatorSignup from './pages/FacilitatorSignup'
import ContactUs from './pages/ContactUs'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import AuthConfirm from './pages/AuthConfirm'

// Admin pages
import AdminDashboard from './pages/AdminDashboard'
import SubmissionDetail from './pages/SubmissionDetail'
import CoupleAnalysis from './pages/CoupleAnalysis'
import ChangePassword from './pages/ChangePassword'
import FacilitatorManagement from './pages/admin/FacilitatorManagement'
import FacilitatorDetail from './pages/admin/FacilitatorDetail'
import ContactSubmissions from './pages/admin/ContactSubmissions'

// Facilitator pages
import FacilitatorDashboard from './pages/facilitator/FacilitatorDashboard'
import FacilitatorProfile from './pages/facilitator/FacilitatorProfile'
import CreateClientPair from './pages/facilitator/CreateClientPair'
import ClientPairDetail from './pages/facilitator/ClientPairDetail'
import FacilitatorManual from './pages/facilitator/FacilitatorManual'

// Client pages
import ClientLayout from './components/ClientLayout'
import SetupPassword from './pages/SetupPassword'
import ClientDashboard from './pages/client/ClientDashboard'
import AuthenticatedSurvey from './pages/client/AuthenticatedSurvey'
import ClientResults from './pages/client/ClientResults'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/facilitator/signup" element={<FacilitatorSignup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/auth/confirm" element={<AuthConfirm />} />
          <Route path="/client/setup-password" element={<SetupPassword />} />
          {/* Legacy redirects */}
          <Route path="/admin/login" element={<Navigate to="/login" replace />} />
          <Route path="/admin/forgot-password" element={<Navigate to="/forgot-password" replace />} />
          <Route path="/admin/reset-password" element={<Navigate to="/reset-password" replace />} />

          {/* Admin routes */}
          <Route path="/admin" element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }>
            <Route index element={<AdminDashboard />} />
            <Route path="submission/:id" element={<SubmissionDetail />} />
            <Route path="couple-analysis/:id" element={<CoupleAnalysis />} />
            <Route path="facilitators" element={<FacilitatorManagement />} />
            <Route path="facilitators/:id" element={<FacilitatorDetail />} />
            <Route path="contact" element={<ContactSubmissions />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          {/* Facilitator routes */}
          <Route path="/facilitator" element={
            <ProtectedRoute allowedRoles={['facilitator']} requireActive>
              <FacilitatorLayout />
            </ProtectedRoute>
          }>
            <Route index element={<FacilitatorDashboard />} />
            <Route path="profile" element={<FacilitatorProfile />} />
            <Route path="create-pair" element={<CreateClientPair />} />
            <Route path="pair/:id" element={<ClientPairDetail />} />
            <Route path="manual" element={<FacilitatorManual />} />
            <Route path="couple-analysis/:id" element={<CoupleAnalysis />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          {/* Client routes */}
          <Route path="/client" element={
            <ProtectedRoute allowedRoles={['client']}>
              <ClientLayout />
            </ProtectedRoute>
          }>
            <Route index element={<ClientDashboard />} />
            <Route path="survey" element={<AuthenticatedSurvey />} />
            <Route path="results" element={<ClientResults />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
